"use client";

import { useEffect, useRef, useState } from "react";

// Vrai tant que l'élément référencé est (même partiellement) à l'écran.
// Sert à masquer la barre CTA collante quand le calendrier est déjà visible.
export function useInView<T extends Element>() {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(([e]) => setInView(e.isIntersecting), {
      threshold: 0.05,
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return [ref, inView] as const;
}
